function getInternetExplorerVersion() {
    var rv = -1;
    if (navigator.appName == 'Microsoft Internet Explorer') {
        var ua = navigator.userAgent;
        var re = new RegExp('MSIE ([0-9]{1,}[0-9.]{0,})');
        if (re.exec(ua) != null) {
            rv = parseFloat(RegExp.$1);
        }
    }
    return rv;
}

function checkVersion() {
    var ver = getInternetExplorerVersion();

    if (ver > -1) {
        if (ver <= 8.0) {
            return true;
        }
    }
    return false;
}

$(function () {
    if (checkVersion() == true) {
        $('form.real-time-check').removeClass('real-time-check');
        $('input[type!=checkbox]').on('focus', function () {
            $(this).val('');
        });
    }

    $('#number-of-employees').mask('000000');
    $('#phone-number').mask(jsGlobalVars.telNumberMask);
    $('#company-tax-number').mask(jsGlobalVars.taxNumberMask);
});
